import type { FC } from 'react';
import { useAppDrawer } from './useAppDrawer';
import useDeviceType from '../../data/useDeviceType';
import { Box, Drawer, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { appStateActions, useAppState } from '../../data/AppState/useAppState';
import SideBar from '../SideBar';
import colors from '@phyllome/helpers/colors';
import useRoute from '../../data/hooks/useRoute';

interface IProps {
  onClose: () => void;
}

const AppDrawer: FC<IProps> = ({ onClose }) => {
  const { state } = useAppDrawer();
  const appState = useAppState();
  const deviceType = useDeviceType();

  const route = useRoute();

  return (
    <Drawer
      variant='persistent'
      anchor='right'
      open={state.isOpen}
      PaperProps={{
        sx: (theme) => ({
          width: deviceType.isDesktop
            ? appState.state.isSidebarExpanded
              ? '100%'
              : '800px'
            : '100%',
          background: theme.palette.mode === 'dark'
            ? '#202020'
            : colors.fog,
          borderLeft: theme.palette.mode === 'dark'
            ? `1px solid ${theme.palette.divider}`
            : 'none',
          boxShadow: theme.palette.mode === 'dark'
            ? '-4px 0 12px rgba(0,0,0,0.4)'
            : 'none',
        }),
      }}
    >
      <Box
        sx={{
          backgroundColor: colors.ocean,
          padding: '4px',
          position: 'sticky',
          top: 0,
          zIndex: 100,
        }}
      >
        <Box sx={{ display: 'flex', lineHeight: '34px', height: '34px' }}>
          <Box>
            <IconButton
              sx={{ color: 'white' }}
              aria-label='close'
              size='small'
              onClick={() => {
                onClose();
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              color: 'white',
              textAlign: 'center',
            }}
          >
            {appState.state.sidebarTitle}
          </Box>
          {deviceType.isDesktop && (
            <Box sx={{ marginLeft: 'auto' }}>
              <IconButton
                sx={{ color: 'white' }}
                aria-label='adjust size'
                size='small'
                onClick={() => {
                  appState.dispatch({
                    type: appState.state.isSidebarExpanded
                      ? appStateActions.CONTRACTSIDEBAR
                      : appStateActions.EXPANDSIDEBAR,
                    payload: null,
                  });
                }}
              >
                {appState.state.isSidebarExpanded ? (
                  <ArrowForwardIcon />
                ) : (
                  <ArrowBackIcon />
                )}
              </IconButton>
            </Box>
          )}
        </Box>
      </Box>
      {/* Keyed on the sidebar path, so a new sidebar view mounts fresh in the
          same render. A key set by an effect mounted it twice. */}
      <div key={route.sidebarPath}>
        {state.isOpen && (
          <SideBar />
        )}
      </div>
    </Drawer>
  );
};

export default AppDrawer;
